import { CommonAPI } from "../Client";

export const getAllCompanyApi = async (payload) => {
  try {
    const response = await CommonAPI.get(`/api/companies`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const getCompanyApi = async (payload) => {
  try {
    const response = await CommonAPI.get(`/api/company/${payload?.userId || 0}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const postCompanyLogoApi = async (payload) => {
  const formData = new FormData();
  formData.append("file", payload.file);
  try {
    const response = await CommonAPI.post(`/api/company/logo`, formData, {
      headers: {
        "Content-Type":
          "multipart/form-data; boundary=----WebKitFormBoundaryTtTi35D4MiWOz5uq",
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const deleteCompanyLogoApi = async (payload) => {
  try {
    const response = await CommonAPI.delete(`/api/company/logo?key=${payload || ""}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const postCompanyApi = async (payload) => {
  try {
    const response = await CommonAPI.post(
      `/api/company?userId=${payload?.userId || 0}`,
      payload
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const updateCompanyApi = async (payload) => {
  try {
    const response = await CommonAPI.put(
      `/api/company?userId=${payload?.userId || 0}`,
      payload
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const deleteCompanyApi = async (payload) => {
  try {
    const response = await CommonAPI.delete(
      `/api/company?userId=${payload?.userId || 0}&companyId=${
        payload?.companyId || 0
      }`,
      payload
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const getAllBrandApi = async (payload) => {
  try {
    // const response = await CommonAPI.get(`/api/brands`);
    const response = await CommonAPI.get(`/api/brands/${payload}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const getBrandApi = async (payload) => {
  try {
    const response = await CommonAPI.get(
      `/api/brand?brandId=${payload?.brandId || 0}`
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const postBrandLogoApi = async (payload) => {
  try {
    const formData = new FormData();
    formData.append("file", payload.file);
    const response = await CommonAPI.post(`/api/brand/logo`, formData, {
      headers: {
        "Content-Type":
          "multipart/form-data; boundary=----WebKitFormBoundaryTtTi35D4MiWOz5uq",
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const deleteBrandLogoApi = async (payload) => {
  try {
    const response = await CommonAPI.delete(`/api/brand/logo?key=${payload || ""}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const postBrandApi = async (payload) => {
  try {
    const response = await CommonAPI.post(
      `/api/brand?companyId=${payload?.companyId || 0}`,
      payload
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const updateBrandApi = async (payload) => {
  try {
    const response = await CommonAPI.put(
      `/api/brand?companyId=${payload?.companyId || 0}`,
      payload
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const deleteBrandApi = async (payload) => {
  try {
    const response = await CommonAPI.delete(
      `/api/brand?brandId=${payload?.brandId || 0}&companyId=${
        payload?.companyId || 0
      }`,
      payload
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const updateCompanyStatusApi = async (payload) => {
  try {
    const response = await CommonAPI.put(
      `/api/company/${payload?.companyId || ""}/status?isActive=${
        payload?.isActive
      }`,
      payload
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const updateCompanyShiprocketTagApi = async (payload) => {
  try {
    const response = await CommonAPI.put(
      `/api/update/company/shiprocket/tag?companyId=${
        payload?.companyId || ""
      }&shipRocketTag=${payload?.shipRocketTag || ''}`,
      payload
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const verifyCompanyApi = async (payload) => {
  try {
    const response = await CommonAPI.put(
      `/api/company/verification?companyId=${payload?.companyId || ""}`,
      payload
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const updateBrandStatusApi = async (payload) => {
  try {
    const response = await CommonAPI.put(
      `/api/brand/${payload?.brandId || 0}/status?active=${
        payload?.active
      }`,
      payload
    );
    return response;
  } catch (error) {
    throw error;
  }
};


export const getSingleCompanyApi = async (payload) => {
  try {
    const response = await CommonAPI.get(`/api/company/${payload?.companyId || 0}`);
    return response;
  } catch (error) {
    throw error;
  }
};
